import React from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";

const Wrapper = styled.div`
  width: 100%;
  height: 80px;
  background: ${props => props.theme.colors.primaryDark};
  margin-bottom: 60px;
  display: flex;
  justify-content: center;
  align-items: center;
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.3);
  img {
    width: 200px;
  }
  @media (max-width: ${props => props.theme.screen.mobile}) {
    margin-bottom: 20px;
    img {
      width: 150px;
    }
  }
`;

const Header = () => (
  <Wrapper>
    <a href="https://www.codecamps.com">
      <img src="/codecamps-logo.png" alt="Codecamps Logo" />
    </a>
  </Wrapper>
);

export default Header;



// WEBPACK FOOTER //
// ./src/welcome-page/Header.js